import { USER_TYPE_ADMIN, USER_TYPE_GUEST, USER_TYPE_ADVISOR, USER_TYPE_ARRANGER, USER_TYPE_INVESTOR } from './prop/UserType'

const menu: Menu[] = [
    {
        path: 'user/detail',
        menuId: 'MyInfo',
        menuName: '내 정보',
        menuIcon: 'person',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
            USER_TYPE_ARRANGER.value,
            USER_TYPE_ADVISOR.value,
            USER_TYPE_INVESTOR.value,
        ],
        param: {
            isAccount: true
        }
    },
    {
        path: 'invest/list',
        menuId: 'InvestList',
        menuName: '투자 물건',
        menuIcon: 'domain',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value
        ]
    },
    {
        path: 'loan/application',
        menuId: 'LoanApplication',
        menuName: '대출 신청',
        menuIcon: 'credit_score',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value
        ]
    },
    {
        path: 'building/content',
        menuId: 'BuildingContent',
        menuName: '요청 물건 내역',
        menuIcon: 'menu',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
            USER_TYPE_ARRANGER.value,
            USER_TYPE_ADVISOR.value,
            USER_TYPE_INVESTOR.value
        ]
    },
    {
        path: 'review/accepts',
        menuId: 'Accepts',
        menuName: '물건 접수',
        menuIcon: 'receipt',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
            USER_TYPE_GUEST.value,
            USER_TYPE_ARRANGER.value,
            USER_TYPE_ADVISOR.value,
            USER_TYPE_INVESTOR.value
        ]
    },
    {
        path: 'user/list',
        menuId: 'UserList',
        menuName: '회원 조회',
        menuIcon: 'person_search',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
        ]
    },
    {
        path: 'lender/list',
        menuId: 'LenderList',
        menuName: '대주 목록 관리',
        menuIcon: 'person_search',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
        ]
    },
    {
        path: 'lender/detail',
        menuId: 'LenderInfo',
        menuName: '대주 정보',
        menuIcon: 'person',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value
        ],
    },
    {
        path: 'lender/save',
        menuId: 'LenderSave',
        menuName: '대주 정보 저장',
        menuIcon: 'person',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
        ],
    },
    {
        path: 'receipt/list',
        menuId: 'ReceiptList',
        menuName: '물건 접수 내역',
        menuIcon: 'menu',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value
        ]
    },
    {
        path: 'credit/proposal',
        menuId: 'CreditProposal',
        menuName: '여신 제안서',
        menuIcon: 'receipt_long',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
        ]
    },
    {
        path: 'credit/direct/list',
        menuId: 'CreditDirectList',
        menuName: '다이렉트 여신 리스트',
        menuIcon: 'menu',
        isDisplay: true,
        authUserTypes: [

        ]
    },
    {
        path: 'credit/direct/proposal',
        menuId: 'CreditDirectProposal',
        menuName: '다이렉트 여신 제안서',
        menuIcon: 'receipt',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
            USER_TYPE_ARRANGER.value,
            USER_TYPE_ADVISOR.value
        ]
    },
    {
        path: 'invest/write/borrower',
        menuId: 'test',
        menuName: '테스트',
        menuIcon: 'receipt',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
            USER_TYPE_ARRANGER.value,
            USER_TYPE_ADVISOR.value
        ]
    },
    {
        path: 'dev/component',
        menuId: 'DevComponent',
        menuName: '개발-컴포넌트',
        menuIcon: 'developer_board',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
        ]
    },
    {
        path: 'review/loanSim',
        menuId: 'LoanSim',
        menuName: '대주 추천',
        menuIcon: 'developer_board',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value,
            USER_TYPE_GUEST.value,
        ]
    },
    {
        path: 'review/appraisal',
        menuId: 'appraisal',
        menuName: '탁감하기',
        menuIcon: 'app_registration',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_GUEST.value,
            USER_TYPE_ADMIN.value,
            USER_TYPE_ARRANGER.value,
            USER_TYPE_ADVISOR.value,
            USER_TYPE_INVESTOR.value,
        ]
    },
    {
        path: 'appraisal/list',
        menuId: 'AppraisalList',
        menuName: '탁상감정 내역',
        menuIcon: 'receipt',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value
        ]
    },
    {
        path: 'dev/table',
        menuId: 'DevTable',
        menuName: '개발-테이블',
        menuIcon: 'developer_board',
        isDisplay: true,
        authUserTypes: [
            USER_TYPE_ADMIN.value
        ]
    },
]

export default Object.freeze(menu)

export interface Menu {
    path?: string
    menuId: string
    menuName: string
    menuIcon: string
    authUserTypes: string[],
    isDisplay: boolean,
    param?: Record<string, any>
}
